import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Buffer } from "buffer";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";

window.Buffer = Buffer; // Make Buffer globally available
/*
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("SW registered: ", registration);

        // Check for updates
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          console.log("SW update found!");

          if (!newWorker) {
            console.warn("No installing service worker available.");
            return;
          }

          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New content is available, refresh
              console.log("New content available, please refresh.");
              if (window.confirm("New version available! Refresh to update?")) {
                window.location.reload();
              }
            }
          });
        });
      })
      .catch((registrationError) => {
        console.log("SW registration failed: ", registrationError);
      });
  });
}
*/
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const googleClientId = process.env.REACT_APP_GOOOGLE_CLIENT_ID || "";
const googleProviderKey = process.env.REACT_APP_GOOGLE_PROVIDER_KEY || "";
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId} nonce={googleProviderKey}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
